
  import {updateCssClass} from '@/helper/CssClassHelper';
  export default {
    components: {
      JobListingFilter: () => import('@/components/elements/JobListingFilter'),
    },
    props: {
      filterParams: {
        type: String,
        required: false,
        default: '',
      },
      useFacets: {
        type: Boolean,
        required: false,
        default: false,
      },
      facets: {
        type: Object,
        required: false,
        default: undefined,
      },
      loading: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data() {
      return {
        dialog: false,
        posSec: 0,
        width: 0,
      };
    },
    computed: {
      isLoaded() {
        const ret = this.loading ? false : true;
        return ret;
      },
    },
    mounted() {
      this.setButtonWidth();
      if (this.isLoaded) {
        this.positionSection();
        this.addSticky(this.position());
      }

      window.addEventListener('resize', this.setButtonWidth);

      window.onscroll = () => {
        this.setButtonWidth();
        this.positionSection();
        this.addSticky(this.position());
      };
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.setButtonWidth);
    },
    methods: {
      setButtonWidth() {
        const element = document.getElementsByClassName(
          'pb-joblisting-job-main-card-standard'
        )[0];
        if (element) {
          this.width = element.offsetWidth;
        }
      },
      position() {
        let el = document.querySelector('#pb-fixed-div-for-filter');
        let pos;
        if (el) {
          for (pos = [0, 0]; el; el = el.offsetParent) {
            pos[0] += el.offsetLeft - el.scrollLeft;
            pos[1] += el.offsetTop - el.scrollTop;
          }
          return pos[1];
        }
      },
      positionSection() {
        const el = document.querySelector('#pb-section-jobs-with-typesense');
        if (el && this.posSec < el.getBoundingClientRect().height)
          this.posSec = el.getBoundingClientRect().height;
      },
      addSticky(position) {
        if (this.isLoaded && this.posSec > 0 && position > 0) {
          if (
            document.documentElement.scrollTop > position + 90 &&
            document.documentElement.scrollTop < this.posSec
          ) {
            updateCssClass(
              'pb-joblisting-filter-mobile-button',
              'pb-listing-filter-mobile-fixed-button',
              'pb-listing-filter-mobile-nofixed-button'
            );
          } else {
            updateCssClass(
              'pb-joblisting-filter-mobile-button',
              'pb-listing-filter-mobile-nofixed-button',
              'pb-listing-filter-mobile-fixed-button'
            );
          }
        }
      },
      setFilterParams(event) {
        this.$emit('listing-filter', event);
        this.dialog = false;
      },
      setFilterParamsAndResetOrderAndPage(event) {
        this.$emit('listing-filter-button', event);
        this.dialog = false;
      },
      resetFilterParams(event) {
        this.$emit('listing-filter-reset', event);
        this.dialog = false;
      },
      closeModal() {
        this.dialog = false;
      },
    },
  };
